/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ExamItemCancelRequestViewModel } from "../types/ExamItemCancelRequestViewModel.ts";

export const examItemCancelRequestViewModelSchema = z.object({
  cancelJustification: z
    .string()
    .describe("Justificativa para o cancelamento da questão. Opcional.")
    .nullish(),
  weight: z.optional(
    z
      .number()
      .int()
      .describe("Peso a ser redistribuído após o cancelamento da questão."),
  ),
}) as unknown as ToZod<ExamItemCancelRequestViewModel>;
